const styles = theme => ({
  root: {
    width: '100%',
    padding: '0 80px',
    [theme.breakpoints.down('lg')]: {
      padding: '0 40px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '0 10px',
    },
    transition: 'padding 0.3s ease-in-out',
  },
  contentWrapper: {
    maxWidth: '1280px',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
  },
  editor: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    gap: '16px',
  },
})

export default styles
